import { connect } from 'react-redux'
import { Component } from "react"
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';

import{ onEditMode } from "../../actions" 
import {word3D}  from '../../game/loader';
import ActionPad from "./ActionPad"

const center = [39.63648, 21.47281]

const pathContext = {
    scene3D: null,
    version: 0,
    toSave: false
}

class ControlObject extends Component{
    constructor(props) {
        super(props)
        
        this.state = pathContext
    }

    async componentDidMount() {
        this.props.notification.addNotification("Scene3D", async (type, msg, arg)=>{
            setTimeout(async ()=>{
                let state = this.makeStateCopy()
                if(msg.container !== "map-world") return
                state.scene3D = arg
                this.setState(state)
            }, 200)

            
            
        })

        
    }


    makeStateCopy(){
        return {
            scene3D: this.state.scene3D,
            version: this.state.version + 1,
            loading: this.state.loading,
            position: this.state.position,
            toSave: this.state.toSave,   
        }
    }
    render() {
       
        if(this.props.objectSelection !== null && this.props.objectSelection.obj){
            return (
            <div className={'controlObj _' + this.props.editMode}>
                <ActionPad position="full" map={this.state.scene3D ? this.state.scene3D.map:null} gltf={this.props.objectSelection? this.props.objectSelection.obj.gltf: null} mode="instance" element3D={this.props.objectSelection?this.props.objectSelection.obj:null}/>
            </div>) 
        }
        else{
            return ""
        }
        
    }
}


const mapDispatchToProps = {
  onEditMode: onEditMode
}

const mapStateToProps = (state) => {  
    return {
        editMode: state.editMode,
        notification: state.notification
    }
}


ControlObject = connect(mapStateToProps, mapDispatchToProps)(ControlObject);

export default ControlObject;
